// Types and map for PCC side panel
export type PccDataSidePanelTypes = 'carePlan' | 'progressNote';

export const PccSidePanelDataMap: Record<PccDataSidePanelTypes, { label: string; idProperty: string }> = {
	carePlan: {
		label: 'Care Plans',
		idProperty: 'carePlanId',
	},
	progressNote: {
		label: 'Progress Notes',
		idProperty: 'progressNoteId',
	},
};
import { endOfDay, min as minDate, startOfDay } from 'date-fns';

export const PccDataPermissions: Record<string, string> = {
	progressNote: 'user/patientProgressNote.read',
	carePlan: 'user/carePlan.read',
	careProfile: 'user/carePlan.read',
	allergyIntolerance: 'user/allergyIntolerance.read',
	condition: 'user/condition.read',
	medication: 'user/medication.read',
	nutritionOrder: 'user/nutritionOrder.read',
	observation: 'user/observation.read',
	supplementOrder: 'user/nutritionOrder.read',
	assessment: 'user/assessments.read',
	episodeOfCare: 'user/episodeOfCare.read',
	immunization: 'user/immunization.read',
	labResult: 'user/labResult.read',
	radiologyResult: 'user/radiologyResult.read'
};


export function toPccStartDateISOString(date): string | null {
	if (!date) return null;

	const dateValue = (date as any).toDate?.() ?? new Date(date);

	return startOfDay(dateValue).toISOString();
}

export function toPccEndDateISOString(date): string | null {
	if (!date) return null;

	const dateValue = (date as any).toDate?.() ?? new Date(date);

	const maxDate = minDate([endOfDay(dateValue), new Date()]);

	return maxDate.toISOString();
}
